var jade = require("/app/app/assets/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div ng-class=\"{&quot;active&quot; : !$ctrl.collapsed}\"><div class=\"question-header\"><od-tooltip ng-click=\"$ctrl.setQuestionId()\"><od-tooltip-target class=\"permalink\"></od-tooltip-target><od-tooltip-hover class=\"dark\">Get Permalink</od-tooltip-hover></od-tooltip><h6 ng-click=\"$ctrl.collapsed = !$ctrl.collapsed\" class=\"question medium-margin-bottom\">{{$ctrl.question}}</h6><div class=\"toggle-symbol\"></div></div><div ng-hide=\"$ctrl.collapsed\" class=\"answer\"><ng-transclude></ng-transclude></div></div>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./javascripts/market/components/od-collapsible-question.jade
 ** module id = 3463
 ** module chunks = 3
 **/